export * as Instrumentation from './config';
export { useObservability } from './openTelemetry';
export * as Attributes from './attributes';

import { createTrace, closeTrace, addAnalytics, addLog, addMetrics } from './openTelemetry';
import { setUserContext, updateLabels } from './coralogix';

export const Observability = {
    createTrace,
    closeTrace,
    addAnalytics,
    addLog,
    addMetrics,
    setUserContext,
    updateLabels,
};
